import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Input,Card,Pagination,Form,Select } from 'antd';
import { app } from '../../config';
import { EditTwoTone } from '@ant-design/icons';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import { dateConverter } from '../../utils/utcDateConversion';
import NoRecordFound from '../../components/common/NoRecordFound';

const Prayers = () => {
  const { t } = useTranslation(['common']);
  const {Search}=Input;
  const [form] = Form.useForm();
  const [prayer,setPrayer] = useState([]);
  const [renderList,setRenderList] = useState([]);
  const [current, setCurrent] = useState(1)
  const [commonData, setCommonData] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [orgdata, setOrgData] = useState('');
  const [pageObj, setPageObj] = useState({});
  const [clearSearch, setClearSearch] = useState(false);

  let navigate = useNavigate();
  const token=getTokenfromUserObj()
  let user = JSON.parse(localStorage.getItem('user'));
  const orgResp = useFetchOrganizations();
  console.log(orgResp);
  let orgObj = orgResp.response ? orgResp.response.data : [];
  const handleClearClick = () => {
    console.log('Clear search called');
    form.resetFields();
    console.log(document.getElementById('search').value);
    document.getElementById('search').value = '';
    setClearSearch(true);
  };
  useEffect(() => {
    const fetchPrayers=async()=>{
      console.log('Fetch prayers')
      const limit=6;
      const offset=0;
      let getPrayerAPI;
      if(user.userType==="A")getPrayerAPI=`${app.URL}/prayertime/view`;
      else if(user.userType==="O")getPrayerAPI=`${app.URL}/prayertime/viewbyorg/${user.organizationId}`;
      const prayerResp=await axios.get(getPrayerAPI,{headers:{auth:token}});
      prayerResp.data?setPrayer(prayerResp.data.data):[];
      prayerResp.data?setCommonData(prayerResp.data.data):[];
      prayerResp.data?setPagesCount(prayerResp.data.data.length):0;
      prayerResp.data?setRenderList(prayerResp.data.data.slice(0,50)):[];
      setClearSearch(false);
      }
      fetchPrayers();

  }, [clearSearch]);

  useEffect(() => {
    const fetchDataByOrg = async () => {
      console.log('fetch data by org');
      let prayerAPI;
      let dataObj = {
        limit: 10,
        offset: 0,
      };
      if (!pageObj.limit) setPageObj(dataObj);

      if (user.userType === 'A') prayerAPI = `${app.URL}/prayertime/viewprayerbyorg/${orgdata}`;
      const prayerResp = await axios.post(prayerAPI, pageObj, { headers: { auth: token } });
      console.log(prayerResp);
      console.log(prayerResp.data.data.data);
      console.log(prayerResp.data.data.count);
      let convertedObj;
      prayerResp.data ? (convertedObj = dateConverter(prayerResp.data.data.data, 'startDate')) : ' ';
      convertedObj = dateConverter(convertedObj, 'endDate');
      prayerResp.data ? setPrayer(convertedObj) : [];
      prayerResp.data ? setCommonData(convertedObj) : [];
      prayerResp.data ? setPagesCount(prayerResp.data.data.count) : 0;
      prayerResp.data ? setRenderList(convertedObj) : [];
    };
    fetchDataByOrg();
  }, [orgdata, pageObj]);
  console.log('PageObj', pageObj);


  const onSearch = async (value) => {
    console.log(value);
    try {
      const result = await axios.post(`${app.URL}/prayertime/search/${value}`,user,{headers:{auth:token}});
      console.log(result.data.data);
      result.data ? setCommonData(result.data.data) : [];
      result.data ? setRenderList(result.data.data.slice(0,50)) : [];
      result.data ? setPagesCount(result.data.data.length) : 0;
      // result.data ? form.setFieldsValue({ ['search']: "" }) : '';  
    } catch (e) {
      console.log('Error');
      console.log(e);
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }
  };

  const onFinish = (values) => {
    console.log('Success:', values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const handleSearchChange = (e) => {
    console.log(e.target.value);
    if (!e.target.value) {
      setRenderList(prayer.slice(0,50));
      setCommonData(prayer);
      setCurrent(1)
      setPagesCount(prayer.length);
    }
  };
  const onChange = async (page, pageSize) => {
    console.log(page, pageSize);
    setCurrent(page);
    if (!page) page = 1;
    let limit = pageSize;
    let reqObj = {
      limit,
      offset: limit * (page - 1),
    };
    console.log(reqObj);
    setPageObj(reqObj);
    setRenderList(commonData.slice(reqObj.offset, reqObj.offset + limit));
  };

  const addPrayer=(e)=>{
    console.log(e);
    if(user.userType==="A")navigate('/prayer/add', { replace: true });
  else if(user.userType==="O")navigate('/prayers/add', { replace: true });
}
const editPrayer = (e) => {
  console.log(e);
  localStorage.setItem('prayerId', JSON.stringify(e.prayerTimeId));
  if(user.userType==="A")navigate('/prayer/edit', { replace: true });
  else if(user.userType==="O")navigate('/prayers/edit', { replace: true });    
};
const selectOrgId = (e) => {
  console.log('Select org Id');
  setOrgData(e);
};

  return (

    <div className='ml-3 col-lg-12 col-md-12 col-sm-12'>
     <div className='row'>
        <div className='col-lg-8 col-md-8 col-sm-12 '>
          <div class='mt-4 fs-3 fw-bold'> {t('Prayer Management')} </div>
        </div>

       {user.userType==="A"?
        <Form
          name='basic'
          form={form}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <div className='row text-left mt-4 mt-2'>
          <div className='col-lg-3 eventselect'>
          <Form.Item
                  form={form}
                  colon={false}
                  name='organizationId'
                  rules={[
                    {
                      required: false,
                      message: 'Select Organization',
                    },
                  ]}
                >
                  <Select
                    className='custom-select-dropdown'
                    listHeight={250}
                    listItemHeight={500}
                    onChange={selectOrgId}
                    style={{
                      display: 'inline-block ',
                    }}
                    placeholder='Select Organization'
                  >
                    {orgObj.map((orgs) => {
                      return (
                        <Option 
                        className="select-option"
                        key={orgs.organizationId} value={orgs.organizationId}>
                          {orgs.organizationName}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
          </div>
          <div className='col-lg-2'>
                <button class='btn btn-primary button'
                  onClick={handleClearClick}
                >
                    Clear
                  </button>
          </div>
          <div className='col-lg-3'>
                <Form.Item
                
                name="search">
                    <Search
                      id='search'
                      className='event-search'
                      placeholder='Search by Prayer'
                      onSearch={onSearch}
                    onChange={handleSearchChange}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();  // Prevents the form from submitting on Enter key press
                        onSearch(e.target.value);  // Calls the search function directly
                      }
                    }}
                      style={{
                        width: 300,
                        height:50
                      }}
                    />
                  </Form.Item>
          </div>
            <div className='col-lg-3 offset-lg-1 text-center col-md-4 col-sm-12'>
              <button class='btn btn-primary button' onClick={addPrayer}>
                Add Prayer
              </button>
            </div>
          </div>
        </Form> :" "}
        {user.userType==="O"?
           <Form
           name='basic'
           form={form}
           initialValues={{
             remember: true,
           }}
           onFinish={onFinish}
           onFinishFailed={onFinishFailed}
           autoComplete='off'
         >
           <div className='row text-right mt-4 mt-2'>
           <div className='col-lg-4 eventSelect'>
    
           </div>
           <div className='col-lg-4'>
           <Form.Item>
                     <Search
                       id='search'
                       className='event-search'
                       placeholder='Search by Title'
                       onSearch={onSearch}
                       onChange={handleSearchChange}
                       style={{
                         width: 300,
                         height:50
                       }}
                     />
                   </Form.Item>
           </div>
             <div className='col-lg-2 offset-lg-1 text-center col-md-4 col-sm-12'>
               <button class='btn btn-primary button' onClick={addPrayer}>
                 Add Prayer
               </button>
             </div>
           </div>
         </Form>:" "}   
      </div>
          <div className='col-lg-11 col-md-12 col-sm-12 '>
      <div class=' styled-table '>
         <table class='table text-black' >
           <thead class='thead-light'>
             <tr>
             {/* <th>{t("ID")}</th> */}
            {user.userType==="A"?<th>{t("Organization")}</th>   :" "} 
                             <th>{t("Prayer")}</th>
                            
                             <th>{t("Iqamah Time")}</th>
                             <th>{t("Start & End Time")}</th>
                             <th>{t("Status")}</th>
                             <th> </th>
             </tr>
           </thead>
           <tbody >

             {renderList
               ? renderList.map((output) => (
                   <tr className='row-hover' onClick={()=>{editPrayer(output)}}>
                     {/* <td style={{width:"100px"}}>{output.prayerTimeId}</td> */}
                     {/* onClick={()=>{editUser(output)}} style={{color:"blue",textDecoration:"underline", width:"160px"}} */}
                     {user.userType==="A"? <td style={{width:"300px"}}>{output.organizationName}</td>:" "}
                     <td style={{width:"250px"}} >{output.prayer?output.prayer:"null"}</td>
                    
                     <td style={{width:"250px"}}>{output.iqamahTime?output.iqamahTime:"N/A"}</td>
                     <td style={{width:"250px"}}>{output.startTime} - {output.endTime}</td>
                   <td style={{width:"250px"}}>{output.isActive===1?"Active":"Inactive"}</td>
                     <td>
                     <EditTwoTone displayName="edit" twoToneColor="blue" style={{fontSize:"20px"}} onClick={()=>{editPrayer(output)}} />
                       {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
                         {t('Edit')}
                       </button> */}
                     </td>
                   </tr>
                 ))
               : ' '}
           </tbody>
         </table>
         {renderList&&renderList.length == 0?<NoRecordFound/>:" "}
       </div>
      </div>
      <Pagination style={{ marginTop: '10px' }} onChange={onChange} current={current} defaultCurrent={current} pageSize={50} total={pagesCount} />
    </div>
  // </div>
  );
};

export default Prayers;
